<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-form-model
      :model="formInline"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      @submit="handleSubmit"
      @submit.native.prevent
    >
      <a-row>
        <a-col :span="12"> 基本信息 </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="商品名称">
            <a-input v-model="formInline.name" placeholder="请输入商品名称">
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="11" :offset="2">
          <a-form-model-item label="销售数量">
            <a-input
              placeholder="请输入销售数量"
              v-model="formInline.stock"
            ></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="门市价">
            <a-input v-model="priceShop" placeholder="请输入门市价"> </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="11" :offset="2">
          <a-form-model-item label="销售价">
            <a-input v-model="formInline.price" placeholder="请输入销售价">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="显示序号">
            <a-input v-model="formInline.sortNum" placeholder="请输入显示序号">
            </a-input>
          </a-form-model-item>
        </a-col>

        <a-col :span="11" :offset="2">
          <a-form-model-item label="游戏币数量">
            <a-input
              v-model="formInline.gameCurrencyNumber"
              placeholder="请输入游戏币数量"
            >
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="限购一份">
            <a-select
              size="default"
              :placeholder="formInline.limited == 0? '不限购一份': formInline.limited == 1? '限购一份': '请选择限购类型'"
              @change="(val) => {formInline.limited = val}">
              <a-select-option value="0" aria-label="不限购一份">不限购一份</a-select-option>
              <a-select-option value="1" aria-label="限购一份">限购一份</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10" :offset="2">

          <a-form-model-item label="每天限购次数">
            <div style="display: flex;align-items: center;gap: 8px;">
              <a-input
                v-model="formInline.purchaseLimit"
                placeholder="请输入限购次数"
              >
              </a-input>
              <a-tooltip  title='优先级：每天限购次数 < 限购一份；如果设置了限购一份，每天限购次数设置不生效'>
                  <span style="font-size: 20px; color:#1890ff; cursor: pointer;">!</span>
              </a-tooltip>
          </div>
          </a-form-model-item>
        </a-col>
        <a-col :span="11">
          <a-form-model-item label="套餐销售日期">
            <a-range-picker
              :placeholder="[formInline.startTime, formInline.endTime]"
              @change="onChange"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-model-item label="套餐升阶推荐">
            <a-switch v-model="formInline.recommend" checked-children="开" un-checked-children="关"></a-switch>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="10">
          <a-form-model-item label="赠送抽奖次数">
            <a-input
                v-model="formInline.giftLottery"
                placeholder="请输入赠送抽奖次数"
              >
              </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="禁用卡类型">
            <a-select
              mode="multiple"
              style="width: 100%"
              placeholder="请选择禁用卡类型"
              v-model="disableCardTypeSelected"
              allowClear
            >
              <a-select-option
                v-for="item in cardTypeOptions"
                :key="item.id"
                :value="item.id"
              >{{ item.cardTypeName }}
              </a-select-option>
            </a-select>
            <div style="color: #999; font-size: 12px; margin-top: 4px;">选择后，持有对应卡类型的会员将无法购买该套餐</div>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="上架星期">
            <a-select
              mode="multiple"
              :default-value="date"
              style="width: 100%"
              placeholder="请选择星期"
              @change="handleChangeDate"
            >
              <a-select-option v-for="(item, index) in dateList" :key="index">
                {{ item.date }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="商品详情">
            <quill-editor
              v-model="introduceContent"
              ref="myQuillEditor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @change="onEditorChange($event)"
            >
            </quill-editor>
          </a-form-model-item>
        </a-col>
      </a-row>
      <!-- <a-row>
        <a-col :span="11">
          <a-form-model-item label="套餐有效期">
            <a-input v-model="formInline.user" placeholder="请输入活动名称">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row> -->
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="封面图">
            <a-upload
              :customRequest="upload"
              :default-file-list="defaultFileList"
              @change="handleChange"
            >
              <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
                上传
              </a-button>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-table :columns="columns" :data-source="data" v-if="show"> </a-table>
    <a-button @click="save">保存</a-button>
    <a-button @click="goBack">返回</a-button>
  </div>
</template>

<script>
import { addTokensList, picUpload, storeInfoCardType } from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "Age",

    dataIndex: "name",
    key: "name",
    slots: { title: "customTitle" },
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Tags",
    key: "tags",
    dataIndex: "tags",
    scopedSlots: { customRender: "tags" },
  },
  {
    title: "Action",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

const data = [
  {
    key: "1",
    name: "John Brown",
    age: 32,
    address: "New York No. 1 Lake Park",
    tags: ["nice", "developer"],
  },
];
// import chooseAnItem from "./chooseAnItem.vue";
export default {
  components: {
    // chooseAnItem,
  },
  data() {
    return {
      date: [],
      introduceContent: "",
      dateList: [
        {
          date: "星期一",
          value: 1,
        },
        {
          date: "星期二",
          value: 2,
        },
        {
          date: "星期三",
          value: 3,
        },
        {
          date: "星期四",
          value: 4,
        },
        {
          date: "星期五",
          value: 5,
        },
        {
          date: "星期六",
          value: 6,
        },
        {
          date: "星期天",
          value: 7,
        },
      ],
      defaultFileList: [],
      priceShop: "",
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      formInline: {
        name: "",
        price: "",
        sortNum: "",
        gameCurrencyNumber: "",
        img: "",
        limited: 0,
        stock: this.num,
        startTime: "",
        endTime: "",
        purchaseLimit:0,
        recommend: false,
        giftLottery:0,
      },
      data,
      columns,
      show: false,
      cardTypeOptions: [],
      disableCardTypeSelected: [],
    };
  },
  mounted() {
    this.loadCardTypeList();
  },
  methods: {
    loadCardTypeList() {
      var storeId = sessionStorage.getItem("shopId");
      if (!storeId) return;
      storeInfoCardType(storeId).then((res) => {
        if (res.data) {
          this.cardTypeOptions = res.data;
        }
      });
    },
    handleChange(info) {
      console.log(info);
      // this.defaultFileList = info.fileList
    },
    onChange(date, dateString) {
      this.formInline.startTime = dateString[0];
      this.formInline.endTime = dateString[1];
    },
    async upload(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error(this.$file_max_size_text);
        return false;
      }
      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);

      await picUpload(form)
        .then((res) => {
          this.formInline.img = res.data;
          console.log(this.defaultFileList);
          file.onSuccess(res, file);
          message.success("上传成功");
        })
        .catch((err) => {
          message.error(this.$file_max_size_text);
        });
    },
    handleSubmit() {},
    handleChangeDate(value) {
      this.date = value;
      console.log(value, "handleChangeDate");
    },
    // onChange(date, dateString) {
    //   console.log(date, dateString);
    // },
    goBack() {
      this.$router.push("/home/tokenPackage/tokenPackageHome");
    },
    showtable(show) {
      this.show = show;
    },
    save() {
      let obj = {
        name: this.formInline.name,
        priceShop: this.priceShop,
        sortNum: this.formInline.sortNum,
        priceDiscount: 10,
        pricePostage: 0,
        shopRunType: 1401,
        typeId: 653,
        typeSonId: 654,
        pricePostageFull: 1,
        spec: [],
        limited: this.formInline.limited,
        hasDistribution: false,
        disableCardTypeList: this.disableCardTypeSelected.map(function(id) {
          var found = this.cardTypeOptions.find(function(item) { return item.id === id; });
          return { id: id, cardTypeName: found ? found.cardTypeName : '' };
        }.bind(this)),
        goodsType: "common",
        numSales: this.formInline.stock,
        shopId: sessionStorage.getItem("shopId"),
        headImgs: [this.formInline.img],
        weekList: this.date,
        introduceContent: this.introduceContent,
        purchaseLimit:this.formInline.purchaseLimit,
        recommend: this.formInline.recommend,
        giftLottery: this.formInline.giftLottery,
      };
      obj.spec.push(this.formInline);
      console.log("obj-------------", obj);
      addTokensList(obj).then((res) => {
        message.success(res.info);
        this.$router.push("/home/tokenPackage/tokenPackageHome");
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/tokenPackage/tokenPackageAdd.vue